export const locationImage = (placeId: string) => ['location-image', placeId] as const

export const locationDrawImages = (
  title: string,
  description?: string,
  emoji?: string,
  searchHelper?: string,
) => ['location-draw-images', title, description, emoji, searchHelper] as const
